const locationTab = (() => {
  const pageLocation = (document.getElementById("pageLocation") != null);
  if (pageLocation) {

    let btn = document.querySelectorAll('.js-tab-btn');
    let cntnt = document.querySelectorAll('.js-tab-cntnt');

    for (let i = 0; i < btn.length; i++) {
      btn[i].addEventListener("click", () => {

        // 押されたiとjが同じだったらactとらない
        for (let j = 0; j < btn.length; j++) {
          if (!(j == i)) {
            // console.log(j);
            btn[j].classList.remove("act");
            cntnt[j].classList.remove("act");
          }
        }

        btn[i].classList.add('act');
        cntnt[i].classList.add('act');


        const fadeElem = cntnt[i].querySelectorAll('.js-com-fade');
        for (let i = 0; i < fadeElem.length; i++) {

          gsap.set(fadeElem[i], {
            opacity: 0,
            y: 20,
          });

          gsap.to(fadeElem[i], {
            opacity: 1,
            y: 0,
            duration: 1.5,
            ease: "power1.out",
            scrollTrigger: {
              trigger: fadeElem[i],
              start: 'top 80%'
            }
          });
        }

        const fadeElem2 = cntnt[i].querySelectorAll('.js-com-img-fade');
        for (let i = 0; i < fadeElem2.length; i++) {
          gsap.set(fadeElem2[i], {
            opacity: 0,
            scale: 1.1,
            filter: "blur(10px)",
          });

          gsap.to(fadeElem2[i], {
            opacity: 1,
            scale: 1,
            filter: "blur(0px)",
            duration: 2.0,
            ease: "power1.out",
            scrollTrigger: {
              trigger: fadeElem2[i],
              start: 'top 80%'
            }
          });
        }

      });
    }

  }
})()
export default locationTab;